import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";

@Injectable()
export class CaMasterService {
  constructor(private auth: AuthenticationService, private http: Http) { }
  //----------------------Ledger-------------------------//
  GetLedger(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Ledger",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getLedgerById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLedgerByCode(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerByCode",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLedgerByGroupId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerByGroupId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLedgerByMainGroupId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerByMainGroupId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LedgerByExcludingGroupId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerByExcludingGroupId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLedgerCode(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerCode",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveLedger(Ledger_Master: any) {
    if (Ledger_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Ledger",
          Ledger_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Ledger",
          Ledger_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteLedger(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Delete_Ledger?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getLedgerBySupplierId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerBySupplierId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLedgerByCustomer(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerByCustomer",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLedgerBydefaultcash(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerBydefaultsettingcasha/c",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getParentGroup(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/get_ParentGroup?CATypeId=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getGroupByUnderId(data: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GroupByUnderID", data,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getGroupByUnderIdtoPromis(data: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GroupByUnderID", data,
        this.auth.getHeader()
      )
      .toPromise();
  }
  //--------------------Ledger-------------------------//

  //---------------------VoucherType------------------//
  getCAVoucherTypeByLevel(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAVoucherType_ByLevel",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetVoucherType(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAVoucherType",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetVoucherTypeById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAVoucherType_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCAVoucherTypeFunction(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAVoucherTypeFunction",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  generateVoucherNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GenerateVoucherNo",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveCAVoucherType(CAVoucherType_Master: any) {
    if (CAVoucherType_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_CAVoucherType",
          CAVoucherType_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_CAVoucherType",
          CAVoucherType_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteCAVoucherType(Id: number) {
    return this.http
      .delete(
        this.auth.baseUrl + "/services/api/v1/Delete_CAVoucherType?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCAVoucherTypeByMainId(Data) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAVoucherTypeByMainId",
        Data,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTaxVouchers(Data) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TaxVouchers",
        Data,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTaxVoucherList(Data) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TaxTransaction_List",
        Data,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTaxTransactionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Taxtransaction_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_VoucherTypeLevel(CompanyId: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_VoucherTypeLevel?CompanyId=" +
        CompanyId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GroupsForVoucherType(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GroupsForVoucherType", Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LedgerForVoucherType(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerForVoucherType", Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_CAVoucherTypeBy_TypeId(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAVoucherTypeBy_TypeId",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_AllCAType(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_AllCAType",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_VoucherTypeByVoucherTypeIds(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_VoucherTypeByVoucherTypeIds",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //---------------------VoucherType------------------//
  //---------------------Group------------------//
  GetCAGroup(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAGroup",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  GetGroupId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAGroupById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getCAGroupByLevelNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAGroupByLevelNo",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getGroupByLevelNoHead(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Get_GetGroupByLevelNoHead?CATypeId=" +
          Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  getGroupByLevelNoSub(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Get_GetGroupByLevelNoSub?CATypeId=" +
          Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  saveGroup(CAGroup_Master: any) {
    if (CAGroup_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/save_CAGroup",
          CAGroup_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/v1/Update_CAGroup",
          CAGroup_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  generateGroupCode(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Generate_Group_Code?Id=" +
          Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  generateLedgerCode(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Generate_Ledger_Code?Id=" +
          Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  //---------------------Group------------------//

  //---------------------CAType------------------//
  GetCAType(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CAType",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //---------------------CAType------------------//
  //------------------- Transactions------------//
  getTransactions(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TransactionByDate",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveTransaction(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Transaction",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updateTransaction(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_Transaction",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getTransactionByTransNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TransactionByTransno",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteTransaction(Id: any) {
    if (Id != 0) {
      return this.http
        .delete(
          this.auth.baseUrl +
          "/services/api/v1/Delete_Transaction?TransNo=" +
          Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  saveTaxTransaction(FilterItems: any) {

    if (FilterItems.TransNo == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_TaxTransaction",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_TaxTransaction",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }


  deleteTaxTransaction(Id: any) {
    if (Id != 0) {
      return this.http
        .post(
          this.auth.baseUrl +
          "/services/api/v1/Delete_TaxTransaction",
          Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  Get_TaxcodeList_ForTaxVoucher() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_TaxcodeList_ForTaxVoucher",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTaxVoucherById_ForTaxVoucher(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetTaxVoucherById_ForTaxVoucher", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_TaxTransaction_ForTaxVoucher(model) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_TaxTransaction_ForTaxVoucher", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_TaxTransaction_ForTaxVoucher(model) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_TaxTransaction_ForTaxVoucher", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Check_ViewCheckTaxTransaction(model) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Check_ViewCheckTaxTransaction", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------------Transactions-----------//
  //---------------------Billpayments----------//
  getBillpayments(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BillPayment",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSupplier(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Supplier",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  loadUnpaidBills(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Load_Unpaidbills",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveBillpayment(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_BillPayment",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updateBillpayment(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_BillPayment",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  savePdcBillpayment(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_PDCBillPayment",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updatePdcBillpayment(FilterItems: any) {
    return this.http
      .put(
        this.auth.baseUrl + "/services/api/v1/Update_PDCBillPayment",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getBillpaymentById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BillPayment_BYId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteBillpayment(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Delete_Billpayment?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  //---------------------Billpayments----------//
  //---------------------PDC-------------------//
  // savePdc(FilterItems: any) {
  //   return this.http
  //     .post(
  //       this.auth.baseUrl + "/services/api/v1/Save_PDCReceipt",
  //       FilterItems,
  //       this.auth.getHeader()
  //     )
  //     .map(res => {
  //       return res.json();
  //     });
  // }
  // updatePdc(FilterItems: any) {
  //   return this.http
  //     .put(
  //       this.auth.baseUrl + "/services/api/v1/Update_PDCReceipt",
  //       FilterItems,
  //       this.auth.getHeader()
  //     )
  //     .map(res => {
  //       return res.json();
  //     });
  // }
  // getPdcByTransNo(FilterItems: any) {
  //   return this.http
  //     .post(
  //       this.auth.baseUrl + "/services/api/v1/Get_PdcByTransNo",
  //       FilterItems,
  //       this.auth.getHeader()
  //     )
  //     .map(res => {
  //       return res.json();
  //     });
  // }
  //---------------------PDC-------------------//
  //---------------------SalesPost-------------//
  Get_UnpostedSalesDates(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_UnpostedSalesDates",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_UnpostedSalesDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_UnpostedSalesDetails",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveSalesPost(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/SaveSalesPost",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_postedSalesDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Load_postedSalesDetails",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  UnPost_Sales(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/UnPost_Sales",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SalesPostDataForCalculate(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesPostDataForCalculate",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_SalesPosting(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SalesPosting",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------------SalesPost-------------//
  //---------------------Taxcode-------------//
  GetTaxcode(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Taxcode",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTaxratebytaxcode(taxcode: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_Taxratebytaxcode?Id=" + taxcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GenerateTaxcode() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/GenerateTaxcode",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveTaxcode(Master: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Taxcode",
        Master,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  DeleteTaxcode(Id: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Delete_Taxcode?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTaxratebyBarcode(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TaxRateByBarcode", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------------Taxcode-------------//
  //---------------------LedgerPosting-------------//
  Get_LedgerPostingList(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerPostingList", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Post_Ledgers(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Post_Ledgers", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LedgerHead(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerHead", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------------LedgerPosting-------------//
  //----------------------Trial balance---------------//
  Get_TrialBalanceRpt(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TrialBalanceRpt", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LevelForTrialBalance() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_LevelForTrialBalance",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //----------------------Trial balance---------------//
  //----------------------Transaction detail Report---------------//
  Get_AccountReportForTransactionDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_AccountReportForTransactionDetails", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LedgerReportForTransactionDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerReportForTransactionDetails", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LedgerForTransactionDetails() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_LedgerForTransactionDetails",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_VoucherForTransactionDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_VoucherForTransactionDetails", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_VoucherTypeByTransnoForTransactionDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_VoucherTypeByTransnoForTransactionDetails", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_PurchaseIdByTransnoForTransactionDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchaseIdByTransnoForTransactionDetails", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_PurchasereturnIdByTransnoForTransactionDetails(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PurchasereturnIdByTransnoForTransactionDetails", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //----------------------Transaction detail Report---------------//

  //----------------------Transaction Doc-------------------------//
  Get_TransactionDoc(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TransactionDoc", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_TransactionDoc(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_TransactionDoc", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //----------------------Transaction Doc-------------------------//
  //----------------------Zatca Report----------------------------//
  Get_ZatcaRptList(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ZatcaRptList", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //----------------------Zatca Report---------------------------//

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/accounts/ca-master.service.ts